import Layout from '../components/layout/Layout';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const TermsOfService = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-secondary py-12" data-testid="terms-page">
        <div className="max-w-4xl mx-auto px-4">
          <Card>
            <CardHeader>
              <CardTitle className="font-serif text-3xl">Allgemeine Geschäftsbedingungen / Terms of Service</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <h2>1. Geltungsbereich</h2>
              <p>
                Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Plattform WEDVAYA, 
                betrieben von der WEDVAYA GmbH ("Plattform").
              </p>

              <h2>2. Leistungsbeschreibung</h2>
              <p>
                WEDVAYA ist eine Vermittlungsplattform, die es Gastgebern ermöglicht, zusätzliche 
                Gäste für ihre Hochzeit zu finden, und Gästen ermöglicht, sich auf Hochzeiten zu bewerben.
              </p>

              <h2>3. Registrierung und Konto</h2>
              <ul>
                <li>Die Registrierung ist ab 18 Jahren möglich</li>
                <li>Nutzer müssen wahrheitsgemäße Angaben machen</li>
                <li>Jeder Nutzer darf nur ein Konto führen</li>
                <li>Die Kontodaten sind vertraulich zu behandeln</li>
              </ul>

              <h2>4. Rollen und Pflichten</h2>
              <h3>Gastgeber (Hosts)</h3>
              <ul>
                <li>Stellen wahrheitsgemäße Informationen über ihre Hochzeit bereit</li>
                <li>Sind verantwortlich für die Durchführung des Events</li>
                <li>Müssen Bewerbungen zeitnah bearbeiten</li>
              </ul>
              <h3>Gäste (Guests)</h3>
              <ul>
                <li>Erstellen ein wahrheitsgemäßes Profil</li>
                <li>Bewerben sich nur auf Events, die sie besuchen können</li>
                <li>Leisten die Zahlung nach Annahme ihrer Bewerbung</li>
              </ul>

              <h2>5. Zahlungen und Gebühren</h2>
              <ul>
                <li>Die Zahlungsabwicklung erfolgt über Stripe</li>
                <li>WEDVAYA erhebt eine Vermittlungsgebühr von 15% auf jede Transaktion</li>
                <li>Die Auszahlung an Gastgeber erfolgt 48 Stunden nach dem Event</li>
                <li>
                  Stornierungen und Ihr gesetzliches Widerrufsrecht sind in unserer{' '}
                  <Link to="/widerrufsrecht" className="text-primary hover:underline">Widerrufsbelehrung</Link>{' '}
                  geregelt
                </li>
              </ul>

              <h2>6. Haftungsausschluss</h2>
              <p>
                WEDVAYA fungiert ausschließlich als Vermittlungsplattform und übernimmt keine 
                Verantwortung für:
              </p>
              <ul>
                <li>Die Durchführung oder Qualität der Events</li>
                <li>Das Verhalten von Gastgebern oder Gästen</li>
                <li>Schäden, die im Zusammenhang mit Events entstehen</li>
                <li>Die Richtigkeit der von Nutzern bereitgestellten Informationen</li>
              </ul>

              <h2>7. Verhaltensregeln</h2>
              <p>Auf der Plattform ist Folgendes untersagt:</p>
              <ul>
                <li>Falsche oder irreführende Angaben</li>
                <li>Belästigung anderer Nutzer</li>
                <li>Umgehung der Zahlungsabwicklung</li>
                <li>Verstoß gegen geltendes Recht</li>
              </ul>

              <h2>8. Kündigung</h2>
              <p>
                Nutzer können ihr Konto jederzeit löschen. WEDVAYA behält sich vor, Konten bei 
                Verstößen gegen diese AGB zu sperren oder zu löschen.
              </p>

              <h2>9. Änderungen der AGB</h2>
              <p>
                WEDVAYA kann diese AGB jederzeit ändern. Nutzer werden über Änderungen informiert. 
                Die weitere Nutzung nach Inkrafttreten gilt als Zustimmung.
              </p>

              <h2>10. Anwendbares Recht und Gerichtsstand</h2>
              <p>
                Es gilt deutsches Recht. Gerichtsstand ist Berlin, Deutschland.
              </p>

              <h2>11. Kontakt</h2>
              <p>
                Die vollständigen Angaben zum Betreiber finden Sie in unserem{' '}
                <Link to="/impressum" className="text-primary hover:underline">Impressum</Link>.<br />
                Email: legal@wedvaya.com
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                Stand: Oktober 2026
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default TermsOfService;
